<!--
 * @Author: heroDHB
 * @Date: 2020-07-29 13:39:11
-->
<template>
  <div>
    <div class="top-container">
      <img class="text" src="../../assets/imgs/home/text-3.png" />
      <img class="decorator" src="../../assets/imgs/home/video-decorator.jpg" />
    </div>
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="id in xcx" :key="id">
          <img class="slide-img" :src="require(`../../assets/imgs/xcx/${id}.jpg`)" />
          <!-- <img class="slide-bg" src="../../assets/imgs/home/xcx-swiper-bg.png" /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper/swiper-bundle.min';

export default {
  name: 'XcxSwiper',
  components: {},
  data() {
    return {
      xcx: [1, 2, 3, 4, 5],
    };
  },
  mounted() {
    // eslint-disable-next-line no-new
    new Swiper('.swiper-container', {
      effect: 'coverflow',
      autoplay: {
        autoplay: true,
        disableOnInteraction: false,
      },
      slidesPerView: 1.5,
      centeredSlides: true,
      loop: true,
    });
  },
};
</script>

<style lang="less" scoped>
.top-container {
  margin-top: 84px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .text {
    height: 34px;
  }
  .decorator {
    width: 750px;
    height: 38px;
  }
}
.swiper-container {
  .swiper-wrapper {
    margin-top: 56px;
    .swiper-slide {
      position: relative;
      .slide-img {
        width: 100%;
        height: 100%;
      }
      .slide-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
